import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { BuildingLeftMenuList } from "../utils/constants";
import { RenderNavItem } from "../components/RenderNavItem";

const Building_Sanction_Ground_Covergae = () => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
        </div>
      </section>
      <section className="section inner-pad1">
        <div className="container ">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu  min-height-400">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {BuildingLeftMenuList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title2 bas">
                    <h3 className="fontSizeClass">
                      {t("Ground Coverage for Buildings")}
                    </h3>
                  </div>
                  <p className="para_building">
                    {t(
                      "Save as otherwise determined by the Mayor-in-Council, with regard to any specification made in this behalf under the West Bengal Town and Country (Planning and Development) Act, 1979, the Floor Area Ratios shall be as specified in Table 3 below"
                    )}
                    :
                  </p>
                  <p className="fontSizeClass"></p>
                  <div className="mayor-table">
                    <table
                      width="95%"
                      border={0}
                      align="center"
                      className="table table-bordered officials"
                    >
                      <tbody>
                        <tr bgcolor="#302ba0" align="center">
                          <td width="10%" rowSpan={2} className="text-white">
                            <div align="center">{t("Sl. No")}</div>
                          </td>
                          <td width="33%" rowSpan={2} className="text-white">
                            <div align="center">
                              {t("Occupancy or user group")}
                            </div>
                          </td>
                          <td colSpan={2} width="20%" className="text-white">
                            <div align="center">
                              {t("Max. Percentage ground coverage")}
                            </div>
                          </td>
                        </tr>
                        <tr bgcolor="#302ba0" align="center">
                          <td
                            width="20%"
                            align="center"
                            valign="middle"
                            className="text-white"
                          >
                            {t("Plot size upto 200 sqm")}
                          </td>
                          <td width="20%" align="center" className="text-white">
                            {t("Plot size 500 sqm or above")}
                          </td>
                        </tr>
                        <tr align="center">
                          <td width="3%">
                            <div align="center">1.</div>
                          </td>
                          <td>
                            <div className="fontSizeClass">
                              {t("Residential")}
                            </div>
                          </td>
                          <td>
                            <div align="center"> 60% </div>
                          </td>
                          <td>
                            <div className="fontSizeClass"> 50% </div>
                          </td>
                        </tr>
                        <tr align="center">
                          <td width="3%" align="center">
                            <div align="center">2.</div>
                          </td>
                          <td>
                            <div className="fontSizeClass">
                              {t("Educational")}
                            </div>
                          </td>
                          <td>
                            <div className="fontSizeClass"> 50% </div>
                          </td>
                          <td>
                            <div align="center"> 45% </div>
                          </td>
                        </tr>
                        <tr align="center">
                          <td width="3%" align="center">
                            <div align="center">3.</div>
                          </td>
                          <td>
                            <div className="fontSizeClass">
                              {t("Institutional")}
                            </div>
                          </td>
                          <td>
                            <div className="fontSizeClass"> 40% </div>
                          </td>
                          <td>
                            <div align="center"> 40% </div>
                          </td>
                        </tr>
                        <tr align="center">
                          <td>
                            <div align="center">4.</div>
                          </td>
                          <td>
                            <div className="fontSizeClass">{t("Assembly")}</div>
                          </td>
                          <td>
                            <div align="center"> 40%</div>
                          </td>
                          <td>
                            <div align="center">40%</div>
                          </td>
                        </tr>
                        <tr align="center">
                          <td align="center">
                            <div align="center">5.</div>
                          </td>
                          <td>
                            <div className="fontSizeClass">
                              {t("Mercantile (retail)")}
                            </div>
                          </td>
                          <td>
                            <div className="fontSizeClass"> 40% </div>
                          </td>
                          <td>
                            <div className="fontSizeClass">40% </div>
                          </td>
                        </tr>
                        <tr align="center">
                          <td align="center">
                            <div align="center">7.</div>
                          </td>
                          <td>
                            <div className="fontSizeClass">
                              {t("Industrial")}
                            </div>
                          </td>
                          <td>
                            <div className="fontSizeClass">40%</div>
                          </td>
                          <td>
                            <div className="fontSizeClass"> 40%</div>
                          </td>
                        </tr>
                        <tr align="center">
                          <td align="center">
                            <div align="center">8.</div>
                          </td>
                          <td>
                            <div className="fontSizeClass">{t("Storage")} </div>
                          </td>
                          <td>
                            <div className="fontSizeClass">40% </div>
                          </td>
                          <td>
                            <div className="fontSizeClass"> 40%</div>
                          </td>
                        </tr>
                        <tr align="center">
                          <td align="center">
                            <div align="center">10.</div>
                          </td>
                          <td>
                            <div className="fontSizeClass">{t("Business")}</div>
                          </td>
                          <td>
                            <div className="fontSizeClass">40% </div>
                          </td>
                          <td>
                            <div className="fontSizeClass"> 40% </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <p className="para_building">
                    2.
                    {t(
                      "For any other size of the plot in between plot size of 200 sq. m. and 500 sq. m., the percentage coverage shall be calculated by direct interpolation."
                    )}
                  </p>
                  <p className="para_building">
                    3.
                    {t(
                      "Notwithstanding anything contained in sub-rule (1), for plots measuring more than 5000 sq. m. in area, the maximum permissible ground coverage shall be 45% for residential building/ buildings and 35% for building/ buildings with other occupancies including mixed occupancy."
                    )}
                  </p>
                  <p className="para_building">
                    4.
                    {t(
                      "For buildings on plots measuring 5000 sq. m, additional ground coverage to the extent of 15% may be allowed for car parking and building services. The additional ground coverage of 15% will be exclusively utilized for car parking, ramps, staircase, lift for upper level car parking and building services such as A.C. plant room, generator room, fire fighting equipments, electrical equipments etc. not exceeding 5% out of such 15% subject to compliance of other relevant rules."
                    )}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Building_Sanction_Ground_Covergae;
